import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { currentLang, currentLongLang } from '../../components/components/utils';
import AppContext from '../../components/AppContext';
import PopupLink from '../../templates/PopupLink';
function Login({navigation}) {

	const appContext = useContext(AppContext);

	const navigateForward = () => {
		appContext.setGlobalSpinnerCount(appContext.globalSpinnerCount + 1);
		let clientId = window.env.amplifyConfig.user_pool_web_client_id;
		let oauth_domain = window.env.amplifyConfig.oauth_domain
		let ui_domain = window.env.amplifyConfig.ui_domain
		let protocol = window.location.protocol
		let backupAuthUrl = `https://${oauth_domain}/oauth2/authorize?identity_provider=auth0&redirect_uri=${protocol}//${ui_domain}/callback&response_type=CODE&client_id=${clientId}&scope=openid profile`
		window.location.replace(backupAuthUrl);
	}

	return (
		<>
		  <p><FormattedMessage id="login.introParagraph.1"/></p>
		  <p><FormattedMessage id="login.introParagraph.2" values={{i: chunks => <i>{chunks}</i>}}/></p>
		  <p>
		    <span className="label label-info"><b><FormattedMessage id="wet.security"/><FormattedMessage id="wet.colon"/></b></span>&nbsp;
		    <FormattedMessage id="login.introParagraph.multifactor" values={
		    	{
		    		a: chunks => <a href={"https://www.cbsa-asfc.gc.ca/eservices/multifactor-help-aide-multifacteur-"+currentLongLang()+".html"}>{chunks}</a>
		    		, nowrap: chunks => <span className="nowrap">{chunks}</span>
		    	}
		    }/>
		  </p>
		  <p><span className="label label-warning"><b><FormattedMessage id="wet.important"/><FormattedMessage id="wet.colon"/></b></span>&nbsp;<FormattedMessage id="login.introParagraph.sharedComputer"/></p>
		  <p><FormattedMessage id="login.introParagraph.toAccessClickHere"/></p>
		  <div className="panel-body full-width" style={window.env.environment !== "prod" && window.env.environment !== "test" ? {border:"1px solid black", backgroundColor:"#f7f7f7"} : {}}>
		      {window.env.environment === "local" || window.env.environment === "dev" || window.env.environment === "dev1" ? 
		        <h4>[Options 1 and 2 aren't available in this environment, only shown for reference purposes]</h4>
		      : <></>}
		    <div className="row">
		      <div className="col-md-6">
		        <div className="well">
		          <h2 className="h4 mrgn-tp-sm"><FormattedMessage id="login.signInPartner.heading"/></h2>
		          <p><FormattedMessage id="login.signInPartner.msg"/></p>
		          <p><FormattedMessage id="wet.note"/><FormattedMessage id="wet.colon"/> <FormattedMessage id="login.signInPartner.note"/></p>
		          <p><a href={window.env["secureKey-url"][currentLang()]} className="btn btn-success btn-block exit" rel="external"><FormattedMessage id="login.signInPartner"/></a></p>
		        </div>
		      </div>
		      <div className="col-md-6">
		        <div className="well">
		          <h2 className="h4 mrgn-tp-sm"><FormattedMessage id="login.gcKey.heading"/></h2>
		          <p><FormattedMessage id="login.gcKey.msg"/></p>
		          <p><a href={window.env["gcKey-url"][currentLang()]} className="btn btn-success btn-block exit" rel="external"><FormattedMessage id="login.gcKey"/></a></p>
		        </div>
		      </div>
		    </div>
		  </div>
		  {window.env.environment !== "prod" ?
		  	<>
		  	  <hr/>
		  	  <div className="panel-body full-width" style={window.env.environment === "test" ? {border:"1px solid black", backgroundColor:"#f7f7f7"} : {}}>
		  	    <h4>[Dev/Test Only, use only if Options 1 and 2 aren't available]</h4>
		  	    <div className="row">
		  	      <div className="col-md-10">
		  	        <div className="well">
		  	          <h2 className="h4 mrgn-tp-sm">3. Log in with a Backup Authentication Provider</h2>
		  	          <p>Authenticate using the backup authentication provider only available in dev/test.</p>
		  	          <p>Note: If this is your first time using this method, you will need to contact the Web Application development team for assistance.</p>
		  	          <button className="btn btn-success btn-block exit" onClick={()=>(navigateForward())}>Auth0 (dev/test only)</button>
		  	        </div>
		  	      </div>
		  	    </div>
		  	  </div>
		  	</>
		  :<></>
		  }
		</>
	);
}

Login.path = "login";
Login.navigationOptions = {
	pageTitle: <FormattedMessage id="login.title"/>
	, breadcrumb: [
		<PopupLink url={window.env["canada-url"][currentLang()]}><FormattedMessage id="breadcrumb.Canada.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.CBSA.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.ACE.text" /></PopupLink>
	]
	, breadcrumbTitle: <FormattedMessage id="login.title"/>
};

export default Login;